import SDURenewalPricing from 'components/SDURenewalPricing/SDURenewalPricing';

export default SDURenewalPricing;
